import React, { useContext, useState } from "react";
import useBreadcrumbs from "../../../utils/hooks/useBreadcrumbs";
import { FaBloggerB } from "react-icons/fa";
import Button from "../../../UI/Button/Button";
import Table from "../../../UI/Table/Table";
import Modal from "../../../UI/Modal/Modal";
import AddOrUpdateComment from "./AddOrUpdateComment";
import { PaginationType } from "../../../Types/APITypes";
import Alert from "../../../UI/Alert/Alert";
import { NotifyContext } from "../../../context/notifyContext";
import ShowComment from "./ShowComment";
import DeleteComment from "./DeleteComment";
import PublishComment from "./PublishComment";
import DisableComment from "./DisableComment";
import {
  CommunityComments,
  CommunityRequestCommentStatusType,
} from "../../../Types/Community";
import CommunityAPI from "../../../services/api/CommunityService";

export default function CommentList() {
  useBreadcrumbs([
    {
      label: "Communauté",
      icon: <FaBloggerB />,
      is_link: true,
      href: "/app/community",
    },
    {
      label: "Commentaires",
      is_link: false,
    },
  ]);

  const notify = useContext(NotifyContext);

  const [error, setError] = useState("");
  const [modal_add, setModalAdd] = useState<{
    open: boolean;
    comment?: CommunityComments | null;
  }>({ open: false, comment: null });

  const [modal_show, setModalShow] = useState<{
    open: boolean;
    comment?: CommunityComments | null;
  }>({ open: false, comment: null });

  const [modal_delete, setModalDelete] = useState<{
    open: boolean;
    comment?: CommunityComments | null;
  }>({ open: false, comment: null });

  const [modal_publish, setModalPublish] = useState<{
    open: boolean;
    comment?: CommunityComments | null;
  }>({ open: false, comment: null });

  const [modal_disable, setModalDisable] = useState<{
    open: boolean;
    comment?: CommunityComments | null;
  }>({ open: false, comment: null });

  const columns = React.useMemo(
    () => [
      {
        Header: "Ajouté le",
        accessor: "created_at",
        Cell: (params: any) => {
          return (
            <div>
              {new Date(params.row.original.created_at).toLocaleString()}
            </div>
          );
        },
      },
      {
        Header: "Message",
        accessor: "content",
        Cell: (params: any) => {
          return (
            <div
              dangerouslySetInnerHTML={{ __html: params.row.original.content }}
            ></div>
          );
        },
      },
      {
        Header: "Article",
        accessor: "post_title",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: (params: any) => {
          const { row } = params;

          return row?.original.status ===
            CommunityRequestCommentStatusType.PUBLISHED ? (
            <span className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
              <svg
                className="h-1.5 w-1.5 fill-green-500"
                viewBox="0 0 6 6"
                aria-hidden="true"
              >
                <circle cx={3} cy={3} r={3} />
              </svg>
              Publié
            </span>
          ) : (
            <span className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
              <svg
                className="h-1.5 w-1.5 fill-red-500"
                viewBox="0 0 6 6"
                aria-hidden="true"
              >
                <circle cx={3} cy={3} r={3} />
              </svg>
              Attente
            </span>
          );
        },
      },
      {
        Header: "Action",
        Cell: (params: any) => {
          const { row } = params;
          return (
            <div className="flex items-center gap-2">
              <Button
                color="info"
                onClick={() =>
                  setModalShow({ open: true, comment: row?.original })
                }
              >
                Voir
              </Button>
              {/* <Button
                color="primary"
                onClick={() =>
                  setModalAdd({ open: true, comment: row?.original })
                }
              >
                Editer
              </Button> */}
              {row.original.status ===
              CommunityRequestCommentStatusType.PUBLISHED ? (
                <Button
                  color="error"
                  onClick={() =>
                    setModalDisable({ open: true, comment: row?.original })
                  }
                >
                  Désactiver
                </Button>
              ) : (
                <Button
                  color="primary"
                  onClick={() =>
                    setModalPublish({ open: true, comment: row?.original })
                  }
                >
                  Valider
                </Button>
              )}
              <Button
                color="error"
                onClick={() =>
                  setModalDelete({ open: true, comment: row?.original })
                }
              >
                Supprimer
              </Button>
            </div>
          );
        },
      },
    ],
    []
  );

  const fetchData = React.useCallback(
    (pagination?: PaginationType) => {
      setLoading(true);
      CommunityAPI.get_post_comments(pagination)
        .then((response: any) => response?.data)
        .then((data: any) => {
          setData(data?.comments || []);
          setTableInfos({
            pageCount: data?.last_page || 1,
            total: data?.total || 0,
          });
          setError("");
        })
        .catch((error) => {
          setError(error);
          notify(error, "error");
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [notify]
  );

  const [data, setData] = React.useState<
    CommunityComments[] | null | undefined
  >();
  const [loading, setLoading] = React.useState(true);
  const [table_infos, setTableInfos] = React.useState({
    pageCount: 0,
    total: 0,
  });

  return (
    <div className="">
      <Modal
        open={modal_add.open}
        title="Ajouter un commentaire"
        onClose={() => {
          setModalAdd({ open: false });
        }}
      >
        <AddOrUpdateComment
          onClose={() => {
            fetchData();
            setModalAdd({ open: false });
          }}
          initialState={modal_add.comment}
        />
      </Modal>

      <Modal
        open={modal_show.open}
        // title={`Informatons ${modal_show.comment?.title}`}
        title={"Commentaire"}
        onClose={() => {
          setModalShow({ open: false });
        }}
      >
        <ShowComment
          onClose={() => {
            fetchData();
            setModalShow({ open: false });
          }}
          comment={modal_show.comment}
        />
      </Modal>

      <Modal
        open={modal_delete.open}
        title={`Supprimer le commentaire`}
        onClose={() => {
          setModalDelete({ open: false });
        }}
      >
        <DeleteComment
          onClose={() => {
            fetchData();
            setModalDelete({ open: false });
          }}
          comment={modal_delete.comment}
        />
      </Modal>

      <Modal
        open={modal_publish.open}
        title={`Publier le commentaire`}
        onClose={() => {
          setModalPublish({ open: false });
        }}
      >
        <PublishComment
          onClose={() => {
            fetchData();
            setModalPublish({ open: false });
          }}
          comment={modal_publish.comment}
        />
      </Modal>

      <Modal
        open={modal_disable.open}
        title={`Désactiver le commentaire`}
        onClose={() => {
          setModalDisable({ open: false });
        }}
      >
        <DisableComment
          onClose={() => {
            fetchData();
            setModalDisable({ open: false });
          }}
          comment={modal_disable.comment}
        />
      </Modal>

      {/* {table_infos.total > 0 && (
        <div className="flex items-center justify-end w-full mb-6">
          <Button color="primary" onClick={() => setModalAdd({ open: true })}>
            Ajouter
          </Button>
        </div>
      )} */}

      <div className="">
        {error && <Alert color="error">{error}</Alert>}

        {/* {pageCount === 0 && loading && <div>Loading</div>} */}

        {loading && table_infos.total === 0 && (
          <div className="flex items-center justify-center w-full p-8">
            <div role="status">
              <svg
                aria-hidden="true"
                className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}

        {table_infos.total === 0 && !loading && (
          <div className="flex flex-col items-center justify-center gap-4 p-4 py-8 border border-dashed rounded border-black/60">
            <p>Aucun commentaire présent</p>
            {/* <Button color="primary" onClick={() => setModalAdd({ open: true })}>
              Ajouter
            </Button> */}
          </div>
        )}

        <Table
          // @ts-ignore
          columns={columns}
          data={data || []}
          fetchData={fetchData}
          loading={loading}
          pageCount={table_infos.pageCount}
          total={table_infos.total}
          className="h-[728px]"
        />
      </div>
    </div>
  );
}
